import React from "react";
import "./BusinessDrive.css";

export default function BusinessDrive() {
  return (
    <div id="business-drive" className="outsourcemainclass">
        <div className="overlay"></div>
      <div className="left">
        <h2 className="heading">
          Powering Faster Delivery with DevOps Automation
        </h2>
        <p className="subheading">
          At BastionEx, we deliver intelligent DevOps automation services that
          accelerate deployments, streamline workflows, and improve software
          reliability. Our solutions reduce manual effort, enhance
          collaboration, and enable continuous delivery for scalable,
          high-performance operations.
        </p>
        <button>Book your free consultation</button>
      </div>
      {/* <div className="right">
            <img src={img} alt="error" />
        </div> */}
    </div>
  );
}
